
/**
 * Formats a number to a specified number of decimal places.
 *
 * @param {number} number - Value that should be formated.
 * @param {number} decimalPlaces - The number of decimal places to format to.
 * @returns {string} The formatted number as a string with the specified number of decimal places.
 */
export const formatDecimal = (number, decimalPlaces) => {
  const numString = number.toString();
  const [integerPart, decimalPart] = numString.split('.');
  const formattedDecimalPart = decimalPart
    ? decimalPart.padEnd(decimalPlaces, '0')
    : '0'.repeat(decimalPlaces);

  return `${integerPart || '0'}.${formattedDecimalPart}`;
};